module.exports = __webpack_public_path__ + "static/tv-995e79c295c45e7601f47ecbf9b7859c.png";